// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SurveyMonkey-module-surveymonkey-ijSlM{max-width:1260px;max-width:var(--des-breakpoint-secondary-xl-container, 1260px);margin-block:0;margin-inline:auto}.SurveyMonkey-module-error-C5LCC{display:flex;justify-content:center;max-width:1260px;max-width:var(--des-breakpoint-secondary-xl-container, 1260px);margin-block:0;margin-inline:auto}", ""]);
// Exports
exports.locals = {
	"surveymonkey": "SurveyMonkey-module-surveymonkey-ijSlM",
	"error": "SurveyMonkey-module-error-C5LCC"
};
module.exports = exports;
